import storeManager from '../store/StoreManager';
import apiService from './api/ApiService';
import assessmentReader from '../store/readHelpers/AssessmentReader';
import clientEventType from '../constants/ClientEventType';
import responseStatusActions from '../actions/ResponseStatusActions';
import { t } from '../../src/services/i18nService';
import questionReader from '../../src/store/readHelpers/QuestionReader';

const autoSaveResponseService = {

    getCandidateWarningExtraInfo(contentRevisionId) {
        const question = assessmentReader.getQuestion(contentRevisionId);
        if (!question) {
            console.warn(
                `AutoSaveResponseService: Question with contentRevisionId ${contentRevisionId} not found.`
            );
            return undefined;
        }
        if (!questionReader.isExtendedText(question)) {
            return undefined;
        }
        return t(
            'autoSave.warnings.extraInfo',
            { contentRevisionId: question.contentRevisionId, title: question.title }
        );
    },

    storeUserResponseSuccess(contentRevisionId) {
        const candidateWarningExtraInfo = this.getCandidateWarningExtraInfo(contentRevisionId);
        const wasAutoSaveFailed = storeManager.getState().responseStatus.autoSaveResponses?.[contentRevisionId]?.success;
        if (candidateWarningExtraInfo && wasAutoSaveFailed) {
            apiService.notifyClientEvent(
                clientEventType.CLIENT_AUTO_SAVE_RECOVERY,
                candidateWarningExtraInfo,
                true
            ).then((response) => {
                if (response.success) {
                    storeManager.dispatch(
                        responseStatusActions.setAutoSaveFailedResponse(
                            contentRevisionId,
                            false
                        )
                    );
                }
            });
        }
    },

    storeUserResponseFail(contentRevisionId) {
        const candidateWarningExtraInfo = this.getCandidateWarningExtraInfo(contentRevisionId);
        if (candidateWarningExtraInfo) {
            apiService.notifyClientEvent(
                clientEventType.CLIENT_AUTO_SAVE_FAILED,
                candidateWarningExtraInfo,
                true
            ).then((response) => {
                if (response.success) {
                    storeManager.dispatch(
                        responseStatusActions.setAutoSaveFailedResponse(
                            contentRevisionId,
                            true
                        )
                    );
                }
            });
        }
    },

};

export default autoSaveResponseService;
